@if (open()) {
  <div class="jl-tutorial-backdrop">
    <section class="jl-tutorial-container" [class.jl-tutorial-container--success]="state() === 'success'" (click)="$event.stopPropagation()">
      @switch (state()) {
        @case ('success') {
          <div class="jl-tutorial-success-state">
            <div class="jl-success-icon">
              <svg class="jl-success-svg" viewBox="0 0 52 52">
                <circle class="jl-success-circle" cx="26" cy="26" r="24" fill="none" />
                <path class="jl-success-check" fill="none" d="M15 27l7 7 15-15" />
              </svg>
            </div>
            <h3 class="jl-success-title">Bağlantı Başarılı!</h3>
            <p class="jl-success-message">Entegrasyon ayarlarınız kaydedildi.</p>
          </div>
        }
        @case ('loading') {
          <header class="jl-tutorial-header">
            <div>
              <h2 class="jl-tutorial-title">{{ title() }}</h2>
              @if (subtitle()) {
                <p class="jl-tutorial-subtitle">{{ subtitle() }}</p>
              }
            </div>
          </header>
          <div class="jl-tutorial-loading-state">
            <div class="jl-spinner"></div>
            <p class="jl-loading-text">Bağlantı kuruluyor...</p>
          </div>
        }
        @default {
          <header class="jl-tutorial-header">
            <div>
              <h2 class="jl-tutorial-title">{{ title() }}</h2>
              @if (subtitle()) {
                <p class="jl-tutorial-subtitle">{{ subtitle() }}</p>
              }
            </div>
          </header>

          <div class="jl-tutorial-body">
            @if (videoSrc()) {
              <div class="jl-tutorial-video-wrap">
                <video [src]="videoSrc()" class="jl-tutorial-video" controls autoplay loop muted playsinline></video>
                <p class="jl-tutorial-sound-hint">
                  <svg class="jl-tutorial-sound-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                  </svg>
                  Sesli anlatım için sesi açınız
                </p>
              </div>
            }

            @if (instructions()) {
              <div class="jl-tutorial-instructions">
                <div class="jl-tutorial-step">
                  <span class="jl-tutorial-step-num">1</span>
                  <span>BizimHesap hesabınıza giriş yapınız.</span>
                </div>
                <div class="jl-tutorial-step">
                  <span class="jl-tutorial-step-num">2</span>
                  <span>Sol menüden ayarlara tıklayıp, <strong>e-Fatura</strong> sekmesine tıklayınız.</span>
                </div>
                <div class="jl-tutorial-step">
                  <span class="jl-tutorial-step-num">3</span>
                  <span>Açılan ekranda <strong>Entegratör Bilgileri</strong>'ne tıklayıp kullanıcı adı ve şifrenizi aşağıdaki kutucuklara yazınız.</span>
                </div>
              </div>
            }

            <div class="jl-tutorial-fields">
              <div class="jl-tutorial-field">
                <label class="jl-tutorial-label" for="tutorialUsername">Kullanıcı Adı</label>
                <input
                  id="tutorialUsername"
                  type="text"
                  class="jl-tutorial-input"
                  [formControl]="username"
                  placeholder="Kullanıcı adınızı giriniz"
                  autocomplete="new-password"
                />
              </div>
              <div class="jl-tutorial-field">
                <label class="jl-tutorial-label" for="tutorialPassword">Şifre</label>
                <div class="jl-tutorial-input-wrap">
                  <input
                    id="tutorialPassword"
                    [type]="showPassword ? 'text' : 'password'"
                    class="jl-tutorial-input jl-tutorial-input--password"
                    [formControl]="password"
                    placeholder="Şifrenizi giriniz"
                    autocomplete="new-password"
                  />
                  <button type="button" class="jl-tutorial-toggle" (click)="togglePassword()" [attr.aria-label]="showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'">
                    @if (showPassword) {
                      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                        <path d="m1 1 22 22" />
                        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                      </svg>
                    } @else {
                      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>

          <footer class="jl-tutorial-footer">
            <button pButton type="button" class="jl-btn-primary" [label]="acceptLabel()" [disabled]="!isValid" (click)="onAccept()"></button>
          </footer>
        }
      }
    </section>
  </div>
}
